import React from "react";
import { Box, Button, Modal, Typography, TextField } from "@mui/material";
import { Container } from "@mui/system";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  textAlign: "center",
};

export default function ClassCodeModal(props) {
  const { classroom } = props;

  return (
    <Modal
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={modalStyle}>
        <Typography id="modal-modal-title" variant="h4" component="h2">
          Join {classroom?.name} with this code!
        </Typography>
        <Container
          sx={{ padding: "20px", paddingTop: "5px", color: "success.main" }}
        >
          <Typography
            id="modal-modal-title"
            variant="h1"
            component="h2"
            sx={{ fontWeight: "500", fontSize: "10em" }}
          >
            {classroom?.code}
          </Typography>
        </Container>
        <Button
          sx={{}}
          onClick={props.handleClose}
          variant="contained"
          color="primary"
          size="large"
        >
          Close
        </Button>
      </Box>
    </Modal>
  );
}
